import { render, staticRenderFns } from "./AutoDetectFileAction.vue?vue&type=template&id=013be29f"
import script from "./AutoDetectFileAction.vue?vue&type=script&lang=js"
export * from "./AutoDetectFileAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports